// extracted by mini-css-extract-plugin
export default {"timeline":"TimelineChart_timeline__vG8BL","tab-animation":"TimelineChart_tab-animation__k1Fh4"};